import {
  IconLock,
  IconShieldCheck,
  IconSparkles,
  type IconProps,
} from "@tabler/icons-react";
import type { ComponentType } from "react";

/**
 * Datos declarativos del panel marketing de /login. Los textos y los
 * iconos viven aquí en lugar de en el componente para que sea trivial
 * agregar/quitar trust points o cambiar copy sin tocar JSX.
 */
export interface TrustPoint {
  icon: ComponentType<IconProps>;
  title: string;
  desc: string;
}

export const TRUST_POINTS: ReadonlyArray<TrustPoint> = [
  {
    icon: IconShieldCheck,
    title: "Auditoría universal",
    desc: "Cada operación queda registrada · accesible para Auditor y Administrador.",
  },
  {
    icon: IconLock,
    title: "Permisos por organización",
    desc: "Cada usuario solo opera sobre las sociedades del grupo que le fueron asignadas.",
  },
  {
    icon: IconSparkles,
    title: "Flujo guiado",
    desc: "FB60 con CFDI único o múltiples facturas · prorrateo automático y póliza SAP lista.",
  },
];

export interface UsuarioDemo {
  email: string;
  rol: string;
}

/**
 * Credenciales que aparecen en el panel "Usuarios de demo" del login.
 * En producción este bloque entero se quita (gate por env). Hoy es el
 * onboarding para stakeholders durante demos.
 */
export const USUARIOS_DEMO: ReadonlyArray<UsuarioDemo> = [
  { email: "admin@multiva.test", rol: "Administrador" },
  { email: "solicitante.tesoreria@multiva.test", rol: "Solicitante" },
  { email: "autorizador.n1@multiva.test", rol: "Autorizador N1" },
  { email: "autorizador.n2@multiva.test", rol: "Autorizador N2" },
  { email: "mesa.control@multiva.test", rol: "Mesa de Control · N3" },
  { email: "auditor@multiva.test", rol: "Auditor" },
];

export const PASSWORD_DEMO = "Demo!2025";
